import { CommonInfoService } from './../../../cart-process/common-info.service';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import datepicker from 'js-datepicker';

interface CalendarMonth {
  id: number;
  name: string;
}

@Component({
  selector: 'calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
  @Input() isBusinessStartDate: boolean;
  @Input() selectedDate: string;
  @Output() selectDate = new EventEmitter<string>();
  @Output() closeCalendar = new EventEmitter<void>();

  public calendarMonths: CalendarMonth[] = [
    {id: 1, name: 'Styczeń'},
    {id: 2, name: 'Luty'},
    {id: 3, name: 'Marzec'},
    {id: 4, name: 'Kwiecień'},
    {id: 5, name: 'Maj'},
    {id: 6, name: 'Czerwiec'},
    {id: 7, name: 'Lipiec'},
    {id: 8, name: 'Sierpień'},
    {id: 9, name: 'Wrzesień'},
    {id: 10, name: 'Październik'},
    {id: 11, name: 'Listopad'},
    {id: 12, name: 'Grudzień'}];
  public calendarYears: number[] = [];
  private picker: any;
  public selectedYear = new Date().getFullYear();
  public selectedMonth = new Date().getMonth() + 1;
  public isVirginBrand: boolean;

  @HostListener('document:mousedown', ['$event'])
  onClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeCalendar.emit();
    }
  }
  constructor(private elementRef: ElementRef,
              private commonInfo: CommonInfoService) {}

  ngOnInit(): void {
    this.createCalendar();

    this.isVirginBrand = this.commonInfo.isVirginBrand;
  }

  private createCalendar(): void {
    const today = Date.now();
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentDay = new Date().getDate();

    this.calendarYears = this.isBusinessStartDate
      ? [...Array(100).keys()].map(x => currentYear - x)
      : [...Array(11).keys()].map(x => x + currentYear);

    this.picker = datepicker('.calendar-header', {
      formatter: (input, date, instance) => {
        const value = date.toLocaleDateString('pl-PL');
        input.value = value;
      },
      onSelect: (instance, date) => {
        const formattedDate = date.toLocaleDateString('pl-PL', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
        this.selectedDate = formattedDate;
        this.selectDate.emit(formattedDate);
      },
      alwaysShow: true,
      startDay: 1,
      dateSelected: this.selectedDate ? this.formatSelectedDate(this.selectedDate) : null,
      minDate: this.isBusinessStartDate
        ? new Date(`${currentYear - 100}-12-31`)
        : new Date(today),
      maxDate: this.isBusinessStartDate
        ? new Date(today)
        : new Date(currentYear + 10, currentMonth, currentDay),
      customDays: ['N', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
    });
  }

  private formatSelectedDate(date: string): Date {
    const splittedDate = date.split('.').map(item => Number(item));
    this.selectedMonth = splittedDate[1];
    this.selectedYear = splittedDate[2];
    return new Date(splittedDate[2], splittedDate[1] - 1, splittedDate[0]);
  }

  protected setCalendarMonth(month: CalendarMonth): void {
    const newDate = new Date(this.selectedYear, month.id - 1, 1);
    this.picker.navigate(newDate);
  }

  protected setCalendarYear(year: number): void {
    const newDate = new Date(year, this.selectedMonth - 1, 1);
    this.picker.navigate(newDate);
  }
}
